import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const BrandColorsSection = ({ formData, errors, onChange }) => {
  const handleColorChange = (field, value) => {
    onChange({ target: { name: field, value } });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Palette" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-text-primary">Brand Colors</h2>
          <p className="text-sm text-text-secondary">Customize visualizer theme colors</p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="space-y-3">
          <label className="block text-sm font-medium text-text-primary">
            Primary Color
          </label>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={formData?.primaryColor}
              onChange={(e) => handleColorChange('primaryColor', e?.target?.value)}
              className="w-16 h-16 rounded-lg border-2 border-border cursor-pointer"
            />
            <div className="flex-1">
              <Input
                type="text"
                name="primaryColor"
                value={formData?.primaryColor}
                onChange={onChange}
                placeholder="#2563EB"
                error={errors?.primaryColor}
              />
            </div>
          </div>
          <div className="bg-muted rounded-lg p-4 flex items-center gap-3">
            <div
              className="w-12 h-12 rounded-lg border border-border"
              style={{ backgroundColor: formData?.primaryColor }}
            />
            <div>
              <p className="text-sm font-medium text-text-primary">Preview</p>
              <p className="text-xs text-text-secondary">Used for buttons and accents</p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <label className="block text-sm font-medium text-text-primary">
            Secondary Color
          </label>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={formData?.secondaryColor}
              onChange={(e) => handleColorChange('secondaryColor', e?.target?.value)}
              className="w-16 h-16 rounded-lg border-2 border-border cursor-pointer"
            />
            <div className="flex-1">
              <Input
                type="text"
                name="secondaryColor"
                value={formData?.secondaryColor}
                onChange={onChange}
                placeholder="#64748B"
                error={errors?.secondaryColor}
              />
            </div>
          </div>
          <div className="bg-muted rounded-lg p-4 flex items-center gap-3">
            <div
              className="w-12 h-12 rounded-lg border border-border"
              style={{ backgroundColor: formData?.secondaryColor }}
            />
            <div>
              <p className="text-sm font-medium text-text-primary">Preview</p>
              <p className="text-xs text-text-secondary">Used for secondary elements</p>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={16} className="text-primary mt-0.5" />
          <div className="text-sm text-text-secondary">
            <p className="font-medium text-text-primary mb-1">Color Guidelines</p>
            <p>Choose colors that provide good contrast for readability. Primary color will be used for CTAs and interactive elements, while secondary color supports the overall theme.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandColorsSection;